<template>
  <div>
    <button
      class="rounded-md border px-2 lg:px-10 py-4 lg:py-10 lg:text-base font-bold
      transform hover:scale-105 shadow-md text-sm
        duration-300"
      :class="isTeacher ? 'bg-beige-academy-200 '
      : 'bg-orange-academy-300 text-white'"
      @click="$emit('click')"
    >
      {{ buttonPlaceholder.toUpperCase() }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    buttonPlaceholder: String,
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },
};
</script>
